export const GAME_RTP_LIST_TRANSLATION_KEYS = [
  "game_rtp_list.info_label",
  "game_rtp_list.close_label",
  "game_rtp_list.hot_title",
  "game_rtp_list.cold_title",
  "game_rtp_list.hot_tab_label",
  "game_rtp_list.cold_tab_label",
] as const;
